import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MODELS } from "../data/models";
import { SITE } from "../data/constants";
import SEO from "../components/SEO";
import Picture from "../components/Picture";
import PageSeoOverride from "../components/PageSeoOverride";
import { useContent, applyOverride } from "../lib/ContentContext";

export default function AllModels() {
  const { overrides, loaded } = useContent();
  const models = MODELS.map((m) => applyOverride(m, overrides[m.slug]));
  return (
    <>
      <SEO
        title="Semua Model BYD - Seal, Atto 3, Dolphin, M6, Atto 1, Sealion 7, Denza D9"
        description="Jelajahi lineup lengkap 7 model BYD resmi: hatchback, SUV, sedan performa, dan MPV keluarga. Harga OTR, spesifikasi, dan konsultasi di BYD Haka Auto Cibubur."
        canonical={`${SITE.domain}/models`}
      />
      <PageSeoOverride pageKey="models" />
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 pb-12">
        <p className="text-xs uppercase tracking-[0.25em] text-[#6E6E73] mb-5 fade-up">
          Lineup Lengkap
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-[#0F0F0F] leading-[1.05] max-w-3xl fade-up fade-up-delay-1">
          Seluruh model BYD <br />
          <span className="italic font-light">tersedia di Cibubur.</span>
        </h1>
        <p className="mt-6 text-base text-[#6E6E73] max-w-xl leading-relaxed fade-up fade-up-delay-2">
          Dari hatchback kompak hingga MPV flagship, 7 unit siap untuk test
          drive dan konsultasi. Unit siap dikirim, didampingi oleh
          tim senior.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-24 lg:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {models.map((m) => (
            <Link
              key={m.slug}
              to={`/model/${m.slug}`}
              className="group rounded-3xl border border-[#E5E5EA] overflow-hidden bg-[#F5F5F7] hover:border-[#0F0F0F]/40 transition-colors"
              data-testid={`all-models-card-${m.slug}`}
            >
              <div className="aspect-[16/10] bg-[#F5F5F7] overflow-hidden relative">
                {loaded ? (
                  <Picture
                    key={m.hero}
                    src={m.hero}
                    alt={m.name}
                    loading="lazy"
                    width={1200}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1400ms] ease-out"
                  />
                ) : (
                  <div className="absolute inset-0 bg-[#EAEAEC] animate-pulse" />
                )}
                {m.featured && (
                  <span className="absolute top-5 left-5 text-[10px] uppercase tracking-[0.2em] bg-[#0F0F0F] text-white px-3 py-1.5 rounded-full font-medium">
                    Unit Terlaris
                  </span>
                )}
              </div>
              <div className="p-7 lg:p-8">
                <p className="text-[10px] uppercase tracking-[0.2em] text-[#86868B]">
                  {m.category}
                </p>
                <div className="mt-2 flex items-start justify-between">
                  <h2 className="text-2xl lg:text-3xl font-medium text-[#0F0F0F]">
                    {m.name}
                  </h2>
                  <ArrowUpRight className="w-5 h-5 text-[#0F0F0F] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </div>
                <p className="text-sm text-[#6E6E73] mt-1">{m.tagline}</p>
                <p className="mt-4 text-sm text-[#6E6E73] leading-relaxed">
                  {m.shortDesc}
                </p>
                <div className="mt-6 pt-5 border-t border-[#E5E5EA] flex items-center">
                  <span className="text-base font-medium text-[#0F0F0F]">
                    {m.priceLabel}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
